
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ImpulsoDigital from "../pages/impulso-digital/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/impulso-digital",
    element: <ImpulsoDigital />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
